import React from 'react';

import css from './ListingGridSkeleton.module.css';

/**
 * Simple animated skeleton grid for the listing results.
 * Rendered only while the initial search is in progress and no listings
 * exist yet — replaced by the actual grid as soon as results arrive.
 */
const ListingGridSkeleton = ({ count = 8 }) => (
  <ul className={css.grid} aria-busy="true" aria-label="Laddar annonser">
    {Array.from({ length: count }).map((_, i) => (
      <li key={i} className={css.card} aria-hidden="true">
        <div className={css.image} />
        <div className={css.body}>
          <div className={`${css.line} ${css.lineTitle}`} />
          <div className={`${css.line} ${css.linePrice}`} />
          <div className={`${css.line} ${css.lineMeta}`} />
        </div>
      </li>
    ))}
  </ul>
);

export default ListingGridSkeleton;
